import React from 'react';
import PropTypes from 'prop-types';
import AngleDown from '../icons/AngleDown';
import UserHelper from '../../helpers/UserHelper';
import * as Roles from '../../resources/UserRole';
import { withCartConfig } from '../../hooks/CartConfigContext';
import { withStorefrontConfig } from '../../hooks/StorefrontSettingsContext';
import CheckBox from '../form-controls/CheckBox';

const PaymentTerms = (props) => {    
    const paymentTermsArray = [{ id: "", instrument: ' ', description: '', brand: '' }, ...props.CartConfig.storefrontPaymentTerms];  
    
    const handleChange = (e) => {
        let paymentInstrument = "";
        const paymentInstruments = props.CartConfig.storefrontPaymentTerms.filter(function (i) {
            return i.id === e.target.value;
        });
        if (paymentInstruments.length > 0 && paymentInstruments[0].instrument.trim()) {
            paymentInstrument = paymentInstruments[0].instrument;
        }
        else if (props.editingQuote) {
            paymentInstrument = props.selectedCustomer.paymentInstrument;
        }

        props.updatePaymentTerms({ "paymentTermId": e.target.value, "paymentInstrument": paymentInstrument });
    }

   

    const handleCashPayment = () => {
        if (props.isCashPayment) {
            props.updatePaymentTerms({ "paymentTermId": "" });            
        }
        else {
            props.updatePaymentTerms({ "paymentTermId": props.StorefrontConfig.settingsList.CashPaymentTerm });
        }
        !props.isCashPayment;
    }

    let isDisabled = props.isFetching || !UserHelper.hasRoles([Roles.EDIT_ORDER_DETAILS], props.currentUser) || props.StorefrontConfig.settingsList.UsesCustomerSpecificPaymentTerms === "1";
    let paymentTermsSingle;
    if (props.StorefrontConfig.settingsList.UsesCustomerSpecificPaymentTerms === "1") {
        let hasMatch = paymentTermsArray.find(term => term.id === props.selectedCustomer.paymentTerms)?.description;
        if (hasMatch) {
            paymentTermsSingle = props.selectedCustomer.paymentTerms + " - " + hasMatch;
        }
        else {
            paymentTermsSingle = props.selectedCustomer.paymentTerms;
        }
    }
    const localized = props.CartConfig.labels;

    if (!paymentTermsSingle && ((props.CartConfig.childComponents.PaymentTerms.shown === false) || !props.CartConfig.storefrontPaymentTerms || props.CartConfig.storefrontPaymentTerms.length < 1)) {
        return null
    }    
    
    return (        
        <React.Fragment>
            <div className="fele-cart-payment-terms" style={{ opacity: isDisabled ? .5 : 1 }} >
                <div className="label">
                    {localized.PaymentTermsLabel}
                </div>
                <div className="fele-cart-storefront-carriers">
                    <div className="fele-content">
                        <div className="input-wrapper">
                            <div className="select-wrapper" style={{ opacity: isDisabled ? 0.5 : 1}}>
                                <select disabled={isDisabled}
                                    style={{ cursor: isDisabled ? 'default' : 'pointer' }}
                                    onChange={handleChange}
                                    value={String(props.paymentTermId ?? '')}
                                >                                        
                                    {
                                        props.StorefrontConfig.settingsList.UsesCustomerSpecificPaymentTerms==="1" ?
                                            <option value={`${props.selectedCustomer.paymentTerms}`}>
                                                {paymentTermsSingle}
                                            </option>

                                            :
                                        paymentTermsArray.map(
                                            (storefrontPaymentTerm, index) =>
                                                storefrontPaymentTerm.id === "" ?                                                    
                                                    <option key={index} value="">
                                                        {localized.SelectLabel}
                                                    </option> :
                                                    <option key={index} value={`${storefrontPaymentTerm.id}`}>
                                                        {storefrontPaymentTerm.id + ' - ' + storefrontPaymentTerm.description}
                                                    </option>

                                        )
                                    }                                              
                                </select>
                                {!isDisabled && <AngleDown />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
            props.CartConfig.childComponents.PaymentInstrument.shown &&
            <div className="fele-cart-payment-instrument"
                style={UserHelper.hasRoles([Roles.EDIT_ORDER_DETAILS], props.currentUser) ? { opacity: 1 } : { opacity: 0.5 }} >
                <div className="label">
                    {localized.PaymentInstrumentLabel}
                </div>
                <div className="fele-content">
                    <div className="input-wrapper" >
                        <input id="PaymentInstrumentInput"
                            type="text"
                            readOnly
                            value={props.paymentInstrument}
                            style={{ cursor: isDisabled ? 'default' : 'pointer' }}
                        />
                    </div>
                </div>
            </div>
            }
            {
                props.CartConfig.childComponents.CashInAdvance.shown && UserHelper.hasRoles([Roles.CAN_SELECT_CASH_PAYMENT], props.currentUser) &&
                <div className="fele-cart-cash-payment"
                    style={props.selectedCustomer.paymentTermId === props.StorefrontConfig.settingsList.CashPaymentTerm ? { opacity: 0.6 } : { opacity: 1 }} >
                    <div className="label">
                        {localized.CashPaymentLabel}
                    </div>
                    <div className="fele-content">
                        <div className="button-wrapper" >
                            <CheckBox onClick={handleCashPayment}
                                disabled={props.selectedCustomer.paymentTermId === props.StorefrontConfig.settingsList.CashPaymentTerm}
                                    checked={props.isCashPayment || props.paymentTermId === props.StorefrontConfig.settingsList.CashPaymentTerm}
                            />
                        </div>
                    </div>
                </div>
            }

        </React.Fragment>
    )
}

PaymentTerms.propTypes = {
    currentUser: PropTypes.object,
    selectedCustomer: PropTypes.object,
    updatePaymentTerms: PropTypes.func,
    paymentTermId: PropTypes.string,
    editingQuote: PropTypes.bool,
    paymentInstrument: PropTypes.string,
    components: PropTypes.object,
    storefrontPaymentTerms: PropTypes.array,
    isCashPayment: PropTypes.bool,
};

export default withStorefrontConfig(withCartConfig(PaymentTerms));